let showError = undefined;

const SetShowError = function (fnShowError) {
    showError = fnShowError;
}

const ShowError = function (error) {
    if (typeof showError !== "function") return;
    showError(error);
}

export default ShowError;

export {
    SetShowError
}